import { frontendURL } from '../../../../helper/URLHelper';
import store from '../../../../store/index';
import { subscriptionGuard } from '../../../../helper/subscriptionHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const WhatsappCampaigns = () => import('./WhatsappCampaigns.vue');
const CampaignDetails = () => import('./CampaignDetails.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: SettingsContent,
      props: route => {
        const path = route.path;
        if (path.endsWith('/one_off')) {
          return {
            headerTitle: 'CAMPAIGN.ONE_OFF.HEADER',
            icon: 'sound-source',
          };
        } else if (path.endsWith('/whatsapp_campaigns')) {
          return {
            headerTitle: 'CAMPAIGN.WHATSAPP.HEADER',
            icon: 'brand-whatsapp',
          };
        } else if (path.endsWith('/details')) {
          return {
            headerTitle: 'CAMPAIGN.WHATSAPP.HEADER',
            icon: 'brand-whatsapp',
          };
        }
        return {
          headerTitle: 'CAMPAIGN.ONGOING.HEADER',
          icon: 'arrow-swap',
        };
      },
      beforeEnter: async (to, from, next) => {
        await subscriptionGuard(to, from, next, store);
      },
      children: [
        {
          path: '',
          redirect: 'ongoing',
        },
        {
          path: 'ongoing',
          name: 'ongoing_campaigns',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: 'one_off',
          name: 'one_off',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: 'whatsapp_campaigns',
          name: 'whatsapp_campaigns',
          meta: {
            permissions: ['administrator'],
          },
          component: WhatsappCampaigns,
          // beforeEnter: async (to, from, next) => {
          //   if (store.getters['getCurrentAccountId'] !== 4) {
          //     return next({ name: 'home' });
          //   }
          //   next();
          // },
        },
        {
          path: 'inbox/:inboxId/whatsapp_campaigns/:id/details',
          name: 'whatsapp_campaigns_details',
          component: CampaignDetails,
          meta: {
            permissions: ['administrator'],
          },
          // beforeEnter: async (to, from, next) => {
          //   if (store.getters['getCurrentAccountId'] !== 1) {
          //     return next({ name: 'home' });
          //   }
          //   next();
          // },
        },
      ],
    },
  ],
};
